import { Button } from "antd"
import { ButtonProps } from "antd/lib/button"
import React from "react"
import { ArrowLeft } from "react-feather"
import { useTranslation } from "react-i18next"
import { useSettingsContext } from "~Features/settings/settings.context"

interface SettingsButtonProps extends ButtonProps {
    labelKey: string
}

export const SettingsButton = ({ icon, labelKey, onClick, type, ...props }: SettingsButtonProps) => {
    const { t } = useTranslation()
    return (
        <Button onClick={onClick} icon={icon} type={type} {...props}>
            <span className="md:block hidden">{t(labelKey)}</span>
        </Button>
    )
}

interface SettingsLayoutProps {
    children: React.ReactNode
    titleKey: string
    preTitle?: React.ReactNode
    titleExtra?: React.ReactNode
    buttons?: React.ReactNode
}

export const SettingsLayout = ({ children, titleKey, preTitle, titleExtra, buttons }: SettingsLayoutProps) => {
    const { t } = useTranslation()
    const { setListVisible } = useSettingsContext()

    return (
        <div id="finway-settings" className="w-full">
            <div className="flex flex-row justify-between items-center  min-h-34 mb-10">
                <div className="flex flex-row justify-between items-center">
                    <span className="sm:hidden max-h-36 mr-5 -ml-4" onClick={() => setListVisible(true)}>
                        <ArrowLeft />
                    </span>
                    {preTitle}
                    <h2 className="mb-0">{t(titleKey)}</h2>
                    {titleExtra}
                </div>
                <div className="ml-10">
                    <div data-testid="finway:system-settings:edit-btn" className="flex gap-10 flex-wrap">
                        {buttons}
                    </div>
                </div>
            </div>

            {children}
        </div>
    )
}
